import t from"react";const e=({children:e})=>e?t.createElement("div",{className:"text-sm text-color-critical"},e):null;export{e as default};
